export interface ComicChapter {
  id: string;
  number: number;
  title: string;
  updatedAt: string;
  views: number;
}

export interface Comic {
  id: string;
  slug: string;
  title: string;
  author: string;
  cover: string;
  description: string;
  categories: string[];
  rating: number;
  views: number;
  status: 'ongoing' | 'completed';
  updatedAt: string;
  chapters: ComicChapter[];
  tags: string[];
}

export const categories = [
  { slug: 'langman', name: '浪漫爱情', icon: 'ri-heart-line' },
  { slug: 'qihuan', name: '奇幻冒险', icon: 'ri-magic-line' },
  { slug: 'dongzuo', name: '动作热血', icon: 'ri-fire-line' },
  { slug: 'xuanyi', name: '悬疑推理', icon: 'ri-search-eye-line' },
  { slug: 'bl', name: 'BL', icon: 'ri-men-line' },
  { slug: 'gl', name: 'GL', icon: 'ri-women-line' },
  { slug: 'dushi', name: '都市生活', icon: 'ri-building-line' },
  { slug: 'gufeng', name: '古风', icon: 'ri-ancient-gate-line' },
];

export const comics: Comic[] = [
  {
    id: '1',
    slug: 'milian-xianjing',
    title: '迷恋爱陷阱',
    author: '金秀雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20romance%20manhwa%20cover%20illustration%2C%20two%20young%20lovers%20facing%20each%20other%20under%20cherry%20blossoms%2C%20soft%20pastel%20color%20palette%2C%20delicate%20linework%2C%20modern%20webtoon%20style%2C%20clean%20simple%20background%20with%20gentle%20lighting%2C%20emotional%20expression%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '林小夏是一个普通的大学生，因为一次意外与校草级学霸江辰产生了交集。原本以为只是一场误会，却没想到从此卷入了一场甜蜜又酸涩的恋爱陷阱中。两个人的世界天差地别，却因为命运的安排越走越近。当真相逐渐浮出水面，她才发现，原来一切都不是偶然……',
    categories: ['langman', 'dushi'],
    rating: 4.8,
    views: 1285000,
    status: 'ongoing',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'c1-1', number: 1, title: '意外的相遇', updatedAt: '2026-07-01', views: 56000 },
      { id: 'c1-2', number: 2, title: '第二次邂逅', updatedAt: '2026-07-08', views: 48200 },
      { id: 'c1-3', number: 3, title: '心跳加速', updatedAt: '2026-07-15', views: 51300 },
      { id: 'c1-4', number: 4, title: '无法忽视的你', updatedAt: '2026-07-22', views: 47800 },
      { id: 'c1-5', number: 5, title: '秘密的开始', updatedAt: '2026-07-29', views: 50200 },
      { id: 'c1-6', number: 6, title: '靠近的心', updatedAt: '2026-08-03', views: 44500 },
    ],
    tags: ['校园', '甜宠', '欢喜冤家', '颜值天花板'],
  },
  {
    id: '2',
    slug: 'jianyu-moshi',
    title: '剑与魔法师',
    author: '李在勋',
    cover: 'https://readdy.ai/api/search-image?query=A%20fantasy%20Korean%20manhwa%20cover%20showing%20a%20young%20warrior%20holding%20a%20glowing%20sword%20with%20magical%20energy%2C%20mystical%20runes%20floating%20in%20the%20air%2C%20dark%20fantasy%20atmosphere%2C%20dramatic%20lighting%2C%20detailed%20armor%20design%2C%20clean%20simple%20dark%20background%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '在一个被魔法与剑统治的世界里，出身平凡的少年艾伦意外觉醒了沉睡千年的传说级魔法天赋。为了寻找失散多年的妹妹，他踏上了冒险之旅。途中结识了一群志同道合的伙伴，也发现了隐藏在王国背后的惊天阴谋。这是一场关于勇气、友情与信念的史诗冒险。',
    categories: ['qihuan', 'dongzuo'],
    rating: 4.9,
    views: 2150000,
    status: 'ongoing',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 'c2-1', number: 1, title: '觉醒之日', updatedAt: '2026-06-15', views: 89700 },
      { id: 'c2-2', number: 2, title: '初入冒险公会', updatedAt: '2026-06-22', views: 78400 },
      { id: 'c2-3', number: 3, title: '迷雾森林', updatedAt: '2026-06-29', views: 82100 },
      { id: 'c2-4', number: 4, title: '精灵族的秘密', updatedAt: '2026-07-06', views: 75600 },
      { id: 'c2-5', number: 5, title: '龙之试炼', updatedAt: '2026-07-13', views: 79300 },
      { id: 'c2-6', number: 6, title: '黑暗势力的崛起', updatedAt: '2026-07-20', views: 81000 },
      { id: 'c2-7', number: 7, title: '命运的十字路口', updatedAt: '2026-07-27', views: 73400 },
      { id: 'c2-8', number: 8, title: '最终的决战前夜', updatedAt: '2026-08-02', views: 69800 },
    ],
    tags: ['冒险', '魔法', '成长', '伙伴羁绊'],
  },
  {
    id: '3',
    slug: 'dushi-yinying',
    title: '都市阴影',
    author: '朴志浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20thriller%20Korean%20manhwa%20cover%20depicting%20a%20mysterious%20figure%20in%20a%20dark%20alley%20with%20neon%20city%20lights%20reflecting%20on%20wet%20pavement%2C%20noir%20atmosphere%2C%20suspenseful%20mood%2C%20clean%20simple%20dark%20background%2C%20dramatic%20shadows%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '繁华都市的背后，隐藏着不为人知的黑暗角落。前刑警韩志勋因一次任务失败而离开警队，成为了一名私家侦探。一天，一位神秘女子找上门来，委托他调查一起看似普通的失踪案。然而随着调查的深入，他发现这背后牵扯到一个庞大的犯罪网络，而真相远比想象中更加可怕。',
    categories: ['xuanyi', 'dushi'],
    rating: 4.7,
    views: 987000,
    status: 'ongoing',
    updatedAt: '2026-08-02',
    chapters: [
      { id: 'c3-1', number: 1, title: '离职', updatedAt: '2026-06-20', views: 45300 },
      { id: 'c3-2', number: 2, title: '神秘委托人', updatedAt: '2026-06-27', views: 42100 },
      { id: 'c3-3', number: 3, title: '第一个线索', updatedAt: '2026-07-04', views: 43800 },
      { id: 'c3-4', number: 4, title: '暗流涌动', updatedAt: '2026-07-11', views: 41500 },
      { id: 'c3-5', number: 5, title: '背后的势力', updatedAt: '2026-07-18', views: 44700 },
      { id: 'c3-6', number: 6, title: '生死追击', updatedAt: '2026-07-25', views: 42900 },
      { id: 'c3-7', number: 7, title: '真相碎片', updatedAt: '2026-08-01', views: 40200 },
    ],
    tags: ['悬疑', '犯罪', '推理', '硬汉'],
  },
  {
    id: '4',
    slug: 'hua-yang-nianhua',
    title: '花样年华',
    author: '崔恩熙',
    cover: 'https://readdy.ai/api/search-image?query=A%20BL%20romance%20Korean%20manhwa%20cover%20showing%20two%20handsome%20young%20men%20in%20school%20uniforms%20sharing%20a%20tender%20moment%20near%20a%20sunlit%20window%2C%20soft%20warm%20lighting%2C%20delicate%20art%20style%2C%20emotional%20atmosphere%2C%20clean%20simple%20background%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '高中二年级的韩佑镇转学到了新学校，他的同桌是全校公认的完美少年沈时温——成绩优异、运动全能、待人温和。然而熟悉之后，佑镇发现时温其实是一个内心孤独的人。两个少年在最美好的年华里相遇，慢慢走进了彼此的心里，一段纯真而美好的故事由此展开。',
    categories: ['bl', 'dushi'],
    rating: 4.9,
    views: 1890000,
    status: 'ongoing',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'c4-1', number: 1, title: '转学生', updatedAt: '2026-06-10', views: 78300 },
      { id: 'c4-2', number: 2, title: '同桌的你', updatedAt: '2026-06-17', views: 74500 },
      { id: 'c4-3', number: 3, title: '图书馆的午后', updatedAt: '2026-06-24', views: 76900 },
      { id: 'c4-4', number: 4, title: '雨天的约定', updatedAt: '2026-07-01', views: 80200 },
      { id: 'c4-5', number: 5, title: '运动会', updatedAt: '2026-07-08', views: 78700 },
      { id: 'c4-6', number: 6, title: '星空下的告白', updatedAt: '2026-07-15', views: 91400 },
      { id: 'c4-7', number: 7, title: '新的开始', updatedAt: '2026-07-22', views: 82800 },
      { id: 'c4-8', number: 8, title: '暑假计划', updatedAt: '2026-07-29', views: 70300 },
      { id: 'c4-9', number: 9, title: '海边之旅', updatedAt: '2026-08-03', views: 65100 },
    ],
    tags: ['校园', '纯爱', '成长', '青春'],
  },
  {
    id: '5',
    slug: 'nushen-jianglin',
    title: '女神降临',
    author: '林智雅',
    cover: 'https://readdy.ai/api/search-image?query=A%20glamorous%20Korean%20manhwa%20cover%20featuring%20a%20beautiful%20woman%20transforming%20her%20appearance%20through%20makeup%2C%20before%20and%20after%20concept%2C%20bright%20fashionable%20style%2C%20clean%20simple%20background%20with%20sparkle%20effects%2C%20modern%20webtoon%20art%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '因为长相平凡，周芷若从小到大都活在自卑中。进入大学后，她通过精湛的化妆技术华丽变身，成为了校园里的"女神"。然而在光鲜亮丽的外表下，她依然害怕被人发现真实的自己。当她遇到了不在乎外表的温暖少年陆衍，她开始思考：真正的美，到底是什么？',
    categories: ['langman', 'dushi'],
    rating: 4.8,
    views: 3200000,
    status: 'ongoing',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'c5-1', number: 1, title: '丑小鸭', updatedAt: '2026-05-01', views: 125600 },
      { id: 'c5-2', number: 2, title: '化妆的秘密', updatedAt: '2026-05-08', views: 118300 },
      { id: 'c5-3', number: 3, title: '大学第一天', updatedAt: '2026-05-15', views: 121400 },
      { id: 'c5-4', number: 4, title: '男神的注意', updatedAt: '2026-05-22', views: 134700 },
      { id: 'c5-5', number: 5, title: '素颜危机', updatedAt: '2026-05-29', views: 142100 },
      { id: 'c5-6', number: 6, title: '真实的我', updatedAt: '2026-06-05', views: 138500 },
      { id: 'c5-7', number: 7, title: '勇敢面对', updatedAt: '2026-06-12', views: 129800 },
      { id: 'c5-8', number: 8, title: '接纳自己', updatedAt: '2026-06-19', views: 115200 },
      { id: 'c5-9', number: 9, title: '新的篇章', updatedAt: '2026-06-26', views: 108900 },
      { id: 'c5-10', number: 10, title: '甜蜜告白', updatedAt: '2026-07-03', views: 135600 },
      { id: 'c5-11', number: 11, title: '恋爱日常', updatedAt: '2026-07-10', views: 122300 },
      { id: 'c5-12', number: 12, title: '新的挑战', updatedAt: '2026-07-17', views: 98700 },
      { id: 'c5-13', number: 13, title: '真心相待', updatedAt: '2026-07-24', views: 95400 },
      { id: 'c5-14', number: 14, title: '幸福的形状', updatedAt: '2026-07-31', views: 89100 },
      { id: 'c5-15', number: 15, title: '我们的故事', updatedAt: '2026-08-03', views: 72300 },
    ],
    tags: ['美妆', '变身', '校园', '治愈'],
  },
  {
    id: '6',
    slug: 'yexing-jieji',
    title: '夜行阶级',
    author: '张贤宇',
    cover: 'https://readdy.ai/api/search-image?query=A%20dark%20action%20Korean%20manhwa%20cover%20showing%20a%20lone%20fighter%20in%20black%20clothing%20standing%20on%20a%20rooftop%20overlooking%20a%20night%20cityscape%2C%20intense%20action%20vibe%2C%20dramatic%20moonlight%2C%20clean%20simple%20dark%20background%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '在首尔的暗夜中，有一个被称为"夜行使者"的神秘组织。他们专门惩处那些游离在法律之外的恶人。主角姜泰武原本是一个普通的大学生，却因为目睹了一场谋杀而被卷入这个危险的暗夜世界。为了保护身边的人，他不得不学会战斗，一步步揭开隐藏在都市阴影下的真相。',
    categories: ['dongzuo', 'xuanyi'],
    rating: 4.7,
    views: 1560000,
    status: 'ongoing',
    updatedAt: '2026-08-01',
    chapters: [
      { id: 'c6-1', number: 1, title: '目击', updatedAt: '2026-06-05', views: 62300 },
      { id: 'c6-2', number: 2, title: '追杀令', updatedAt: '2026-06-12', views: 58700 },
      { id: 'c6-3', number: 3, title: '夜行使者', updatedAt: '2026-06-19', views: 61400 },
      { id: 'c6-4', number: 4, title: '训练开始', updatedAt: '2026-06-26', views: 57900 },
      { id: 'c6-5', number: 5, title: '第一次任务', updatedAt: '2026-07-03', views: 60800 },
      { id: 'c6-6', number: 6, title: '地下擂台', updatedAt: '2026-07-10', views: 64300 },
      { id: 'c6-7', number: 7, title: '组织的秘密', updatedAt: '2026-07-17', views: 59700 },
      { id: 'c6-8', number: 8, title: '背叛', updatedAt: '2026-07-24', views: 67200 },
      { id: 'c6-9', number: 9, title: '孤身奋战', updatedAt: '2026-07-31', views: 52800 },
    ],
    tags: ['动作', '犯罪', '复仇', '成长'],
  },
  {
    id: '7',
    slug: 'chuan-yue-gudai-dang-laopo',
    title: '穿越古代当老婆',
    author: '安素妍',
    cover: 'https://readdy.ai/api/search-image?query=A%20historical%20fantasy%20Korean%20manhwa%20cover%20showing%20a%20modern%20woman%20in%20traditional%20Korean%20hanbok%20in%20an%20ancient%20palace%20setting%2C%20time%20travel%20theme%2C%20elegant%20and%20romantic%20mood%2C%20clean%20simple%20background%20with%20traditional%20motifs%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '普通白领苏念念在一场车祸后醒来，发现自己穿越到了古代朝鲜成为了一个贵族家的小姐。还没等她适应这个身份，就被告知要与当朝最冷酷无情的王爷成婚。面对这个陌生的世界和即将到来的婚姻，她决定用自己的现代思维来改变命运，却没想到这位冷面王爷有着不为人知的温柔一面。',
    categories: ['gufeng', 'langman'],
    rating: 4.8,
    views: 2450000,
    status: 'ongoing',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 'c7-1', number: 1, title: '车祸', updatedAt: '2026-05-15', views: 98600 },
      { id: 'c7-2', number: 2, title: '陌生的世界', updatedAt: '2026-05-22', views: 94500 },
      { id: 'c7-3', number: 3, title: '婚约', updatedAt: '2026-05-29', views: 102300 },
      { id: 'c7-4', number: 4, title: '初见王爷', updatedAt: '2026-06-05', views: 108700 },
      { id: 'c7-5', number: 5, title: '王府生活', updatedAt: '2026-06-12', views: 97800 },
      { id: 'c7-6', number: 6, title: '朝堂风云', updatedAt: '2026-06-19', views: 89400 },
      { id: 'c7-7', number: 7, title: '暗流涌动', updatedAt: '2026-06-26', views: 86700 },
      { id: 'c7-8', number: 8, title: '真心', updatedAt: '2026-07-03', views: 105600 },
      { id: 'c7-9', number: 9, title: '危机来临', updatedAt: '2026-07-10', views: 92300 },
      { id: 'c7-10', number: 10, title: '生死与共', updatedAt: '2026-07-17', views: 98700 },
      { id: 'c7-11', number: 11, title: '真相大白', updatedAt: '2026-07-24', views: 91400 },
      { id: 'c7-12', number: 12, title: '幸福的归宿', updatedAt: '2026-07-31', views: 85600 },
    ],
    tags: ['穿越', '古风', '宫廷', '甜宠'],
  },
  {
    id: '8',
    slug: 'youxi-moliren',
    title: '游戏模拟人',
    author: '郑允浩',
    cover: 'https://readdy.ai/api/search-image?query=A%20futuristic%20sci-fi%20Korean%20manhwa%20cover%20showing%20a%20virtual%20reality%20game%20world%20with%20holographic%20interfaces%20and%20a%20skilled%20gamer%2C%20neon%20colors%2C%20digital%20aesthetic%2C%20cyberpunk%20elements%2C%20clean%20simple%20dark%20background%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '2045年，全息虚拟现实游戏《永恒之境》风靡全球。职业玩家金贤宇在游戏中意外获得了一个隐藏职业"模拟人"，可以复制任何见过的技能。这个看似弱小的职业，在贤宇的操作下展现出惊人的潜力。然而他也发现，这款游戏背后似乎隐藏着一个改变现实世界的惊天秘密。',
    categories: ['qihuan', 'dongzuo'],
    rating: 4.6,
    views: 1120000,
    status: 'ongoing',
    updatedAt: '2026-08-02',
    chapters: [
      { id: 'c8-1', number: 1, title: '游戏开始', updatedAt: '2026-06-08', views: 53400 },
      { id: 'c8-2', number: 2, title: '隐藏职业', updatedAt: '2026-06-15', views: 51200 },
      { id: 'c8-3', number: 3, title: '第一场副本', updatedAt: '2026-06-22', views: 49800 },
      { id: 'c8-4', number: 4, title: '公会邀请', updatedAt: '2026-06-29', views: 52500 },
      { id: 'c8-5', number: 5, title: '刷级之路', updatedAt: '2026-07-06', views: 54700 },
      { id: 'c8-6', number: 6, title: 'BOSS战', updatedAt: '2026-07-13', views: 56800 },
      { id: 'c8-7', number: 7, title: '职业联赛', updatedAt: '2026-07-20', views: 60200 },
      { id: 'c8-8', number: 8, title: '游戏背后的秘密', updatedAt: '2026-07-27', views: 58300 },
      { id: 'c8-9', number: 9, title: '数据乱流', updatedAt: '2026-08-01', views: 47900 },
    ],
    tags: ['游戏', 'VR', '科幻', '竞技'],
  },
  {
    id: '9',
    slug: 'yueliang-huayuan',
    title: '月亮花园',
    author: '尹智秀',
    cover: 'https://readdy.ai/api/search-image?query=A%20GL%20romance%20Korean%20manhwa%20cover%20showing%20two%20beautiful%20young%20women%20sitting%20together%20in%20a%20moonlit%20garden%20filled%20with%20glowing%20flowers%2C%20dreamy%20atmosphere%2C%20soft%20pastel%20colors%2C%20ethereal%20lighting%2C%20clean%20simple%20background%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '画家沈如月搬到了海边小镇，住进了一栋带有神秘花园的老房子。每天晚上，花园里的花朵在月光下会发出柔和的光芒。她在那里遇到了同样喜欢在月下散步的女孩白露。两个孤独的灵魂因为这片月亮花园而相遇，一场美丽而温柔的恋爱悄然绽放。',
    categories: ['gl', 'langman'],
    rating: 4.8,
    views: 876000,
    status: 'ongoing',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 'c9-1', number: 1, title: '搬家', updatedAt: '2026-06-12', views: 42300 },
      { id: 'c9-2', number: 2, title: '月下花园', updatedAt: '2026-06-19', views: 41500 },
      { id: 'c9-3', number: 3, title: '白露', updatedAt: '2026-06-26', views: 43800 },
      { id: 'c9-4', number: 4, title: '画中的你', updatedAt: '2026-07-03', views: 45600 },
      { id: 'c9-5', number: 5, title: '海边的约定', updatedAt: '2026-07-10', views: 47200 },
      { id: 'c9-6', number: 6, title: '雨天的咖啡', updatedAt: '2026-07-17', views: 44800 },
      { id: 'c9-7', number: 7, title: '心的方向', updatedAt: '2026-07-24', views: 46300 },
      { id: 'c9-8', number: 8, title: '告白之夜', updatedAt: '2026-07-31', views: 52100 },
      { id: 'c9-9', number: 9, title: '我们的月亮花园', updatedAt: '2026-08-03', views: 38900 },
    ],
    tags: ['文艺', '治愈', '海边', '慢热'],
  },
  {
    id: '10',
    slug: 'xuezu-jichengzhe',
    title: '血族继承者',
    author: '权泰亨',
    cover: 'https://readdy.ai/api/search-image?query=A%20vampire%20supernatural%20Korean%20manhwa%20cover%20showing%20a%20mysterious%20aristocratic%20figure%20with%20pale%20skin%20and%20blood-red%20eyes%20in%20a%20gothic%20mansion%20setting%2C%20dark%20elegant%20style%2C%20clean%20simple%20dark%20background%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '古老的吸血鬼家族"血月"面临着前所未有的危机——最后的纯血继承者崔时宇拒绝了继承家族的使命，选择隐藏在人类社会做一个普通的大学生。然而当来自欧洲的吸血鬼猎人家族追查到他的踪迹，他不得不重新面对自己的身份。在人类和吸血鬼两个世界之间，他必须做出选择。',
    categories: ['qihuan', 'dongzuo'],
    rating: 4.7,
    views: 1340000,
    status: 'ongoing',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 'c10-1', number: 1, title: '普通大学生', updatedAt: '2026-06-01', views: 58900 },
      { id: 'c10-2', number: 2, title: '血色觉醒', updatedAt: '2026-06-08', views: 61200 },
      { id: 'c10-3', number: 3, title: '猎人来袭', updatedAt: '2026-06-15', views: 59400 },
      { id: 'c10-4', number: 4, title: '家族的召唤', updatedAt: '2026-06-22', views: 56700 },
      { id: 'c10-5', number: 5, title: '吸血鬼议会', updatedAt: '2026-06-29', views: 58300 },
      { id: 'c10-6', number: 6, title: '两个世界的边界', updatedAt: '2026-07-06', views: 54600 },
      { id: 'c10-7', number: 7, title: '远古的诅咒', updatedAt: '2026-07-13', views: 60200 },
      { id: 'c10-8', number: 8, title: '最后的纯血', updatedAt: '2026-07-20', views: 62500 },
      { id: 'c10-9', number: 9, title: '决战前夕', updatedAt: '2026-07-27', views: 57800 },
      { id: 'c10-10', number: 10, title: '继承者的抉择', updatedAt: '2026-08-02', views: 53400 },
    ],
    tags: ['吸血鬼', '超自然', '家族', '抉择'],
  },
  {
    id: '11',
    slug: 'chongzu-jindiantang',
    title: '宠祖金殿堂',
    author: '韩智敏',
    cover: 'https://readdy.ai/api/search-image?query=A%20cute%20romantic%20comedy%20Korean%20manhwa%20cover%20of%20a%20couple%20with%20height%20difference%2C%20the%20girl%20looking%20up%20at%20a%20tall%20handsome%20man%2C%20playful%20and%20sweet%20vibe%2C%20bright%20warm%20colors%2C%20clean%20simple%20background%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '小个子女孩金多喜梦想成为一名优秀的糕点师，却阴差阳错进入了由身高185cm的冷酷甜点大师车睿渊掌管的"金殿堂"甜品店工作。身高差28cm的两人在日常的碰撞中产生了奇妙的化学反应。当甜甜的甜点遇到了甜甜的爱情，一切都变得美好了起来。',
    categories: ['langman', 'dushi'],
    rating: 4.8,
    views: 1780000,
    status: 'completed',
    updatedAt: '2026-07-15',
    chapters: [
      { id: 'c11-1', number: 1, title: '面试失败', updatedAt: '2026-03-01', views: 78600 },
      { id: 'c11-2', number: 2, title: '意外录取', updatedAt: '2026-03-08', views: 75400 },
      { id: 'c11-3', number: 3, title: '第一天上班', updatedAt: '2026-03-15', views: 81200 },
      { id: 'c11-4', number: 4, title: '马卡龙的秘密', updatedAt: '2026-03-22', views: 76800 },
      { id: 'c11-5', number: 5, title: '甜点大赛', updatedAt: '2026-03-29', views: 84500 },
      { id: 'c11-6', number: 6, title: '意外的一吻', updatedAt: '2026-04-05', views: 96700 },
      { id: 'c11-7', number: 7, title: '心动瞬间', updatedAt: '2026-04-12', views: 89300 },
      { id: 'c11-8', number: 8, title: '竞争对手出现', updatedAt: '2026-04-19', views: 78100 },
      { id: 'c11-9', number: 9, title: '误会', updatedAt: '2026-04-26', views: 82300 },
      { id: 'c11-10', number: 10, title: '和好如初', updatedAt: '2026-05-03', views: 86700 },
      { id: 'c11-11', number: 11, title: '甜点与爱情', updatedAt: '2026-05-10', views: 79400 },
      { id: 'c11-12', number: 12, title: '幸福的甜味', updatedAt: '2026-05-17', views: 105200 },
    ],
    tags: ['甜点', '职场', '身高差', '心动'],
  },
  {
    id: '12',
    slug: 'moshu-shaonu',
    title: '魔术少女',
    author: '孙艺琳',
    cover: 'https://readdy.ai/api/search-image?query=A%20magical%20girl%20Korean%20manhwa%20cover%20featuring%20a%20young%20female%20magician%20performing%20card%20tricks%20with%20glowing%20magical%20effects%2C%20mysterious%20and%20whimsical%20atmosphere%2C%20clean%20simple%20dark%20background%20with%20sparkles%2C%20vertical%20portrait%20composition&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '高中生柳艺恩有一个不为人知的秘密——她是一名真正的魔法师。在这个魔法已经消失的世界里，她只能将魔法伪装成"魔术"表演出来。当她被星探发掘参加全国魔术大赛后，她发现自己并不是唯一的魔法使。一场关于魔法、友情与梦想的大赛即将开始。',
    categories: ['qihuan', 'dushi'],
    rating: 4.6,
    views: 765000,
    status: 'ongoing',
    updatedAt: '2026-08-01',
    chapters: [
      { id: 'c12-1', number: 1, title: '秘密', updatedAt: '2026-06-18', views: 34500 },
      { id: 'c12-2', number: 2, title: '星探', updatedAt: '2026-06-25', views: 33200 },
      { id: 'c12-3', number: 3, title: '初赛', updatedAt: '2026-07-02', views: 35700 },
      { id: 'c12-4', number: 4, title: '另一个魔法使', updatedAt: '2026-07-09', views: 36800 },
      { id: 'c12-5', number: 5, title: '魔法对决', updatedAt: '2026-07-16', views: 38400 },
      { id: 'c12-6', number: 6, title: '隐藏的实力', updatedAt: '2026-07-23', views: 35100 },
      { id: 'c12-7', number: 7, title: '半决赛', updatedAt: '2026-07-30', views: 32900 },
    ],
    tags: ['魔法', '竞技', '成长', '青春'],
  },
];